import "angular";
import { LocalizeFilter } from "./filters/localize.filter";

const mod = angular.module("localization", []);
mod.filter("localize", LocalizeFilter);

export default mod.name;
